import { apiRoutesV2 } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  create(params) {
    const url = apiRoutesV2.inviteEvents();
    return FetchHelpers.post(url, params);
  },
};
